import { CONTRACT, SECTION } from 'constants/global';
import Debugger from 'utils/debugger';
import PuntoredApi from './repository';

export async function createReference(paymentKey, monto, amount, type, id, paymentName, coverage, coverageId) {
  try {
    const response = await PuntoredApi.createReference({
      paymentKey: paymentKey || null,
      monto,
      amount,
      contractType: type,
      contract_id: type === CONTRACT ? id : null,
      section_id: type === SECTION ? id : null,
      os: window.getOS() || 'WEB',
      payment_name: paymentName,
      coverage,
      coverage_id: coverageId || null,
    });
    return response;
  } catch (error) {
    Debugger.error(error);
    return false;
  }
}

export async function createMultipleReference(totalAmount, orders) {
  try {
    const response = await PuntoredApi.createMultipleReference({
      totalAmount,
      orders,
      os: window.getOS() || 'WEB',
    });
    return response;
  } catch (error) {
    Debugger.error(error);
    return false;
  }
}

export async function getPuntoredPDF(externalOrder) {
  return PuntoredApi.getPDF(externalOrder)
    .then((blob) => {
      window.share('puntored', blob, 'application/pdf');
    });
}

export async function deleteReference(referenceId) {
  try {
    const response = await PuntoredApi.deleteReference(referenceId);
    return response;
  } catch (error) {
    Debugger.error(error);
    return false;
  }
}
